import { Reader } from './bytes';
import type { FrameEvent } from './cof';

export interface AnimRecord {
  name: string; // COF name, e.g. "BANUHTH"
  framesPerDirection: number;
  /** Frames advance by speed/256 per game tick (25 Hz). */
  speed: number;
  events: FrameEvent[];
}

/**
 * `AnimData.D2`: authoritative frame counts, speeds and event frames for every COF.
 * 256 hash buckets; each is a count followed by 160-byte records.
 */
export function decodeAnimData(data: Uint8Array): Map<string, AnimRecord> {
  const r = new Reader(data);
  const out = new Map<string, AnimRecord>();
  for (let bucket = 0; bucket < 256 && r.remaining >= 4; bucket++) {
    const count = r.u32();
    for (let i = 0; i < count; i++) {
      const name = r.fixedStr(8).toUpperCase();
      const framesPerDirection = r.u32();
      const speed = r.u32();
      const ev = r.bytesN(144);
      const events: FrameEvent[] = Array.from(ev.subarray(0, framesPerDirection)) as FrameEvent[];
      out.set(name, { name, framesPerDirection, speed, events });
    }
  }
  return out;
}
